import React, { useState } from 'react'
import { BottomNavigationAction } from '@material-ui/core'


import { ReactFC } from '../types'

import { CreatePageIcon, useLocationSelectedIcon } from './navigation-places'

import CreateModal from 'Modals/Create/CreateModal'
import { Link, useLocation } from 'react-router-dom'
import { useTheme } from '@material-ui/core'
import { useOpenCreateModal } from './useOpenCreateModal'



export const BottomNavigationAdd: ReactFC<any> = (props) => {
    const location = useLocation()
    const theme = useTheme()  
    const href = location.pathname
    const size = theme.iconSize

    return (
        <BottomNavigationAction
            label="page"
            icon={<CreatePageIcon size={size} />}
            showLabel={false}
            component={Link}
            data-intro="create-post"
            to={href}
            {...props}
        />
    )
}


export const CreateBottomNavigationAction: ReactFC = () => {
    const [openModal, setOpenModal] = useOpenCreateModal()
    
    const onClick = (event) => {
        event.preventDefault()
        setOpenModal(!openModal)
    }
    return (
        <>
            <CreateModal handleClose={() => setOpenModal(false)} open={openModal} />
            <BottomNavigationAdd onClick={onClick} />
        </>
    )
}

